module.exports = __SPARKY_LIBS__.PanWDSReactTableV6;